//scroll to next card
function nextCard( e, carousel, forwards ){
  let container = null;
  let width = 0;
  //get card contianer el
  [...carousel.childNodes].forEach( function( child, index ){
    if( child.className == 'carousel-container' ){
      container = carousel.childNodes[index];
      width = container.clientWidth;
    }
  })
  //if forwards or backwards
  if(!forwards){
    width = width * (-1);
  }

  if (document.body.classList.contains('ie-browser')) {
    container.scrollLeft = parseInt(container.scrollLeft, 10) + width;
  } else {
    container.scrollTo({
      top: 0,
      left: parseInt(container.scrollLeft, 10) + width,
      behavior: 'smooth'
    })
  }

}


//bind
[...document.getElementsByClassName('card-carousel')].forEach( function( carousel ){
  [...carousel.childNodes].forEach( function( child, index ){
    //get next button el
    if( child.className == 'next-card' ){
      let nextButton = carousel.childNodes[index];
      nextButton.addEventListener( 'click', (e) => { nextCard(e, carousel, true) } );
    }
    //get last button el
    if( child.className == 'last-card' ){
      let lastButton = carousel.childNodes[index];
      lastButton.addEventListener( 'click', (e) => { nextCard(e, carousel, false) } );
    }
  })
})
